// extracted by mini-css-extract-plugin
export var active = "step-indicator-module--active--11325";
export var indicatorLine = "step-indicator-module--indicator-line--0343a";
export var stepIcon = "step-indicator-module--step-icon--4090c";
export var stepIndicator = "step-indicator-module--step-indicator--1861f";
export var stepWrapper = "step-indicator-module--step-wrapper--04385";
export var visuallyHidden = "step-indicator-module--visually-hidden--3b31f";